import { render, staticRenderFns } from "./CombinedBasicInfoPrintTransferWriteOff.vue?vue&type=template&id=35bd825c&scoped=true&"
import script from "./CombinedBasicInfoPrintTransferWriteOff.vue?vue&type=script&lang=js&"
export * from "./CombinedBasicInfoPrintTransferWriteOff.vue?vue&type=script&lang=js&"
import style0 from "./CombinedBasicInfoPrintTransferWriteOff.vue?vue&type=style&index=0&id=35bd825c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bd825c",
  null
  
)

export default component.exports